<template>
  <div class="app-page-container full" :class="getCustomPageContainerClasses" :style="getCustomStyles">
    <ELYXDropdown v-if="activeDropdown && activeDropdown.id" />
    <div class="fixed-top full" :class="BackgroundComponent ? 'app-page-underlay' : ''">
      <component v-if="BackgroundComponent" :is="BackgroundComponent"> </component>

      <!-- @NB SUPPORT ICON MUST ALSO EXIST ON MOBILE BUT IS CURRENTLY TOTALLY F'ED UP IN CODE SO IT IS HIDDEN -->
      <SupportIcon v-if="isAuthenticated && ($route.meta.calendar || $route.meta.communityPage || $route.meta.session) && !$isMobile" />
      <MiniGuidelines v-if="miniGuidelines && isAuthenticated" />
    </div>
    <!-- <div class="fixed-top full"> -->
    <!-- Here below we see why the generic class based thing is shit, you have no idea looking here WHAT this box is in the visual,
     what the heck is 'fixed-top flex-column full', I have no idea what place I am styling currently. You need named classes. -->
    <div class="fixed-top flex-column full" :class="customBackgroundContainerClasses">
      <div class="top-notice" v-if="isAuthenticated && !$route.meta.session && showBanner && !bannerDisabled">
        Big big apologies for the 2 hour downtime as I crashed the app & failed to run it again!
        <a href="https://www.cofocus.one/communities/cofocus/posts/6723d9d40e3abd001fe4360d" target="_blank">Community post.</a>
        <span @click="closeBanner">X</span>
      </div>
      <!-- <div class="top-notice" v-if="showNav && isAuthenticated && $route.meta.calendar && showSurvey">
        {{ surveySegmentText }}
        <span @click="goToSurvey" style="margin-left: 3px">Take the survey (~3 mins)</span>
      </div> -->
      <!-- without fixed top wrapper the nav did not have bgcolor #css -->
      <!-- <div class="flex-column full"> -->
      <div v-if="showNav && !$route.meta.hideNavigation" :class="getPageNavContainerClasses" :style="`background-color: ${navBackgroundColor};`">
        <Nav v-if="isAuthenticated" :clean="clean" />
        <LandingNav v-else :navBackgroundLight="navBackgroundLight" />
      </div>
      <div class="page-container" :class="getPageContainerClasses">
        <slot></slot>
        <MobileNav v-if="isAuthenticated && $isMobile" />
        <Footer v-if="$route.meta.isPublic" :footerColor="footerColor" />
      </div>
      <Tasks v-if="tasksOpen" />
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Nav from "@/components/Nav/Nav";
import LandingNav from "@/pages/Cofocus/LandingNav";
import CustomCalendarBackground from "@/customizableComponents/CustomCalendarBackground";

import { checkVisibilitySupport } from "../utilities/utilities";
import { checkUserHasNotifications } from "../api/messengerAPI";
import messengerSocket from "../socket/messengerSocket";
import Footer from "../pages/Cofocus/Sections/Footer.vue";
import SupportIcon from "../components/Widgets/SupportIcon.vue";
import MiniGuidelines from "../components/Widgets/InfoModal/MiniGuidelines.vue";

/** ELYX — The New Way */
import ELYXDropdown from "../ELYXComponents/ELYXDropdown.vue";
import { ELYXCentralStore } from "../ELYX/ELYXStore";
import ELYXEventListener from "../ELYX/ELYXEventListener";

import MobileNav from "@/components/Nav/MobileNav.vue";

import Tasks from "@/components/Nav/Dropdowns/Tasks.vue";
import TasksStore from "@/components/Nav/Dropdowns/TasksStore.js";

export default {
  name: "AppPageContainer",
  components: {
    Nav,
    MobileNav,
    LandingNav,
    CustomCalendarBackground,
    Footer,
    SupportIcon,
    MiniGuidelines,
    ELYXDropdown,
    Tasks,
  },
  props: {
    showNav: {
      type: Boolean,
      default: false,
    },
    footerColor: {
      type: String,
      default: "#fff",
    },
    navBackgroundColor: {
      type: String,
      default: "transparent",
    },
    background: {
      type: String,
    },
    navBackgroundLight: {
      type: Boolean,
      default: false,
    },
    customBackground: {
      type: String,
    },
    UID: {
      type: String,
    },
    clean: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      backgroundImage: "https://ik.imagekit.io/elysiumone/Official/landingbackground_KDEqT54wb.avif",

      visibilityChange: "",
      visibilityState: "",

      lastRefocusInMS: 0,

      showNotice: true,

      bannerDisabled: true,
      showBanner: true,
      bannerVersion: 4,
    };
  },
  async created() {
    window.addEventListener("beforeunload", this.cleanBeforeLeave);
    await this.initRefocusUpdate();
    ELYXEventListener.initELYXGlobalEventListener();
  },
  mounted() {
    this.updateBackgroundImage();
    this.checkCookie();
  },
  beforeRouteLeave(to, from, next) {
    this.cleanBeforeLeave(true, next);
  },
  beforeDestroy() {
    this.cleanBeforeLeave();
    ELYXEventListener.stopELYXGlobalEventListener();
  },
  computed: {
    activeDropdown: () => ELYXCentralStore.state.activeDropdown,

    ...mapState({
      user: (state) => state.auth.user,
      isAuthenticated: (state) => state.auth.authenticationStatus,

      sessionCount: (state) => state.userstats.sessionCount,

      messengerOpen: (state) => state.messages.modalOpened,
      currentConversationID: (state) => state.messages.currentConversationID,

      miniGuidelines: (state) => state.modals.miniGuidelines,
    }),
    tasksOpen: () => TasksStore.state.isOpen,

    surveySegmentText() {
      if (this.sessionCount < 80) {
        return "Decide what comes next & get a badge!";
      } else if (this.sessionCount >= 80) {
        return "As one of our top community users, you get to decide what comes next — you'll get a badge in return!";
      }
      return "";
    },

    BackgroundComponent() {
      if (this.background) {
        return "CustomCalendarBackground";
      }
      return null;
    },
    getPageContainerClasses() {
      let classes = "";
      if (this.showNav && !this.$route.meta.calendar) {
        classes = classes + "page-container-subtract-nav";
      }
      if (this.showNav && !this.showNotice && this.$route.meta.calendar) {
        classes = classes + "page-container-subtract-nav";
      }
      if (this.showNav && this.showNotice && this.$route.meta.calendar && this.$windowWidth > 1501) {
        classes = classes + "page-container-subtract-nav-with-notice-wide";
      }
      if (this.showNav && this.showNotice && this.$route.meta.calendar && this.$windowWidth > 769 && this.$windowWidth < 1502) {
        classes = classes + "page-container-subtract-nav-with-notice-medium";
      }
      if (this.showNav && this.showNotice && this.$route.meta.calendar && this.$windowWidth > 545 && this.$windowWidth < 770) {
        classes = classes + "page-container-subtract-nav-with-notice-small";
      }
      if (this.showNav && this.showNotice && this.$route.meta.calendar && this.$windowWidth < 546) {
        classes = classes + "page-container-subtract-nav-with-notice-mini";
      }
      if (!this.isAuthenticated) {
        classes = classes + " " + "overflow-scroll-y";
      }
      return classes;
    },
    getPageNavContainerClasses() {
      let classes = "";
      if (this.isAuthenticated) {
        classes += "app-page-nav-container" + " ";
      }
      if (this.$isMobile) {
        classes += "app-page-nav-container--mobile" + " ";
      }
      return classes;
    },
    getCustomStyles() {
      let styles = "";
      if (this.customBackground) {
        styles = `background: ${this.customBackground};`;
      }
      if (this.$route.meta.newLandingPage) {
        styles = styles + ` background: url('${this.backgroundImage}');`;
        styles = styles + " background-size: cover !important;";
      }
      return styles;
    },
    getCustomPageContainerClasses() {
      let classes = "";
      if (this.clean) {
        classes = classes + " " + "app-page-container--clean";
      }
      if (this.$route.meta.newLandingPage) {
        classes = " app-page-container--cover";
      }
      return classes;
    },
    customBackgroundContainerClasses() {
      let classes = "";
      if (!this.isAuthenticated || (this.isAuthenticated && this.$route.meta.landingPage)) {
        classes = classes + " " + "overflow-hidden-x";
      }
      return classes;
    },
  },
  methods: {
    async cleanBeforeLeave(fromBeforeLeave = false, next = null) {
      document.removeEventListener(this.visibilityChange, this.refocus);
      window.removeEventListener("beforeunload", this.cleanBeforeLeave);

      if (fromBeforeLeave && next !== null) {
        next();
      }
    },
    goToSurvey() {
      window.mixpanel.track("Open PMF Survey");
      window.open(`https://tally.so/r/wzE5Vk?ref=cofocus&uid=${this.user._id}`, "_blank");
    },
    async initRefocusUpdate() {
      /* When person refocuses */
      const { visibilityChange, visibilityState } = checkVisibilitySupport();
      if (visibilityChange != null && visibilityState != null) {
        this.visibilityChange = visibilityChange;
        this.visibilityState = visibilityState;
        /* Check if content is visible */
        document.addEventListener(this.visibilityChange, this.refocus, false);
      }
    },
    async refocus() {
      if (this.$route.meta.isSession) return;
      /* Check if content is visible OR if document has focus post visibility change */
      if (document[this.visibilityState] == "visible" || document.hasFocus()) {
        console.log("Tab is visible OR got refocused!");
        /* If > 5 seconds passed since last update, update again
        Doesn't matter too much as it's a rare case someone madly switches tabs */
        const nowInMS = Date.now();
        const fifteenSecondsInMS = 5 * 1000;
        const timeSinceRefocusMS = nowInMS - this.lastRefocusInMS;
        if (timeSinceRefocusMS > fifteenSecondsInMS) {
          const response = await checkUserHasNotifications();
          /* console.log("response from notifications: ", response); */
          if (response.notifs) {
            if (response.notifs.msg === true) {
              this.$store.dispatch("indicators/turnOffIndicator", "messenger");
            }
            if (response.notifs.connections) {
              this.$store.dispatch("indicators/turnOffIndicator", "connectRequests");
            }
          }
          /* In case a message has been received in an otherwise
         inactive tab where the Messenger Modal is open, and
         then the user returns to that tab, then if new messages
         have arrived, they're set to a state of having been read. */
          if (this.messengerOpen) {
            messengerSocket.setMessagesAsSeen();
            if (this.currentConversationID) {
              await messengerSocket.setConvoAsRead(this.currentConversationID);
            }
          }
          this.lastRefocusInMS = Date.now();
          /* console.log("refreshed"); */
        } else {
          /* console.log("too early"); */
          console.log("time in seconds since last update", timeSinceRefocusMS / 1000);
        }
      } else if (document[this.visibilityState] == "hidden") {
        console.log("Tab lost visibility");
      } else if (!document.hasFocus()) {
        console.log("Tab lost focus");
      }
    },

    /** BANNER COOKIE STUFF */
    closeBanner() {
      this.showBanner = false;
      this.setCookie(`bannerClosed_v${this.bannerVersion}`, "true", 365);
    },
    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = "expires=" + date.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
    },
    checkCookie() {
      const cookieName = `bannerClosed_v${this.bannerVersion}`;
      const bannerClosed = this.getCookie(cookieName);
      this.showBanner = bannerClosed !== "true";
    },
    getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },

    async updateBackgroundImage() {
      /** If .avif is not supported, such as on Safari, use .webp file format instead */
      const avifIsSupported = await this.checkAvifSupport();
      console.log("AVIF SUPPORTED", avifIsSupported);
      if (!avifIsSupported) {
        this.backgroundImage = `https://ik.imagekit.io/elysiumone/Official/landingbackground_zX7CVnvpg.webp`;
      }
    },

    checkAvifSupport() {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = "https://ik.imagekit.io/elysiumone/Official/avifsupportcheckimage_Ysf1FrRUz.avif";
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
      });
    },
  },
};
</script>
<style>
:root {
  --nav-height: 45px;
  /* --nav-padding-top: 2px;
  --nav-padding-bottom: 2px; */
  --nav-margin-top: 10px;
  --nav-margin-bottom: 0px;
  --nav-border-bottom: 1px;
  --nav-border-top: 1px;
  --notice-height-wide: 40px;
  --notice-height-medium: 60px;
  --notice-height-small: 80px;
  --notice-height-tiny: 100px;

  --dropdown-position-left: 0px;
  --dropdown-position-top: 0px;

  --primary-color: #333;
  --secondary-color: #666;
  --tertiary-color: #777;

  --button-color: #333;
  --button-color-hover: #555;
}

.app-page-container {
  position: relative;
  width: 100%;
  height: 100vh;
}

.app-page-container--cover {
  background-size: cover !important;
}

.fixed-top {
  position: absolute;
  top: 0;
  left: 0;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.app-page-nav-container {
  /* remove nav from top and side borders, i.e. non-touching */
  /* margin-top: var(--nav-margin-top);
  margin-bottom: var(--nav-margin-bottom); */
  padding-top: var(--nav-margin-top);
  padding-bottom: var(--nav-margin-bottom);
  padding-left: 25px;
  padding-right: 25px;
  /* remove margins from width */
  width: calc(100% - 50px);
  flex: 0 0;
  z-index: 10;
}
.app-page-nav-container--mobile {
  padding-top: 5px;
}
.app-page-container--clean {
  /* When clean is applied */
  padding-left: 20px;
  padding-right: 20px;
  width: calc(100% - 40px);
}
.flex-column > .app-page-nav-container {
  flex: 0 0;
}
.flex-column > .page-container {
  flex: 1 1;
  height: 100%;
}
.flex-column > .page-container-subtract-nav {
  height: calc(100% - var(--nav-height) - var(--nav-margin-top) - var(--nav-margin-bottom) - var(--nav-border-top) - var(--nav-border-bottom));
}
.flex-column > .page-container-subtract-nav-with-notice-wide {
  height: calc(
    100% - var(--nav-height) - var(--nav-margin-top) - var(--nav-margin-bottom) - var(--nav-border-top) - var(--nav-border-bottom) -
      var(--notice-height-wide)
  );
}
.flex-column > .page-container-subtract-nav-with-notice-medium {
  height: calc(
    100% - var(--nav-height) - var(--nav-margin-top) - var(--nav-margin-bottom) - var(--nav-border-top) - var(--nav-border-bottom) -
      var(--notice-height-medium)
  );
}
.flex-column > .page-container-subtract-nav-with-notice-small {
  height: calc(
    100% - var(--nav-height) - var(--nav-margin-top) - var(--nav-margin-bottom) - var(--nav-border-top) - var(--nav-border-bottom) -
      var(--notice-height-small)
  );
}
.flex-column > .page-container-subtract-nav-with-notice-tiny {
  height: calc(
    100% - var(--nav-height) - var(--nav-margin-top) - var(--nav-margin-bottom) - var(--nav-border-top) - var(--nav-border-bottom) -
      var(--notice-height-tiny)
  );
}
.app-page-underlay {
  background: var(--calendar-background-color);
  background-size: 100% 100%;
}
.full {
  height: 100%;
  width: 100%;
}
.overflow-scroll-y {
  overflow-y: scroll;
}
.overflow-hidden-x {
  overflow-x: hidden;
}
.margin-center {
  margin-left: auto;
  margin-right: auto;
}
.flex-column-reverse {
  display: flex;
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}

.justify-center {
  justify-content: center;
}

.top-notice {
  width: calc(100% - 40px);
  background-color: #111;
  font-weight: 500;
  padding: 10px 20px;
  color: white;
  line-height: 20px;
  text-align: center;
  position: relative;
}
.top-notice a,
.top-notice span {
  color: #8888ff;
  cursor: pointer;
}
.top-notice a:hover,
.top-notice span:hover {
  color: #a5a5fd;
}
.top-notice span {
  position: absolute;
  right: 15px;
  color: #c5c5c5;
}
.top-notice span:hover {
  color: #969696;
}
</style>
